export const faltasList = [
  { value: "low", label: "Pouca falta" },
  { value: "medium", label: "Falta moderada" },
  { value: "high", label: "Muita falta" },
];
export const faltasLabelMap = {
  low: "Pouca falta",
  medium: "Falta moderada",
  high: "Muita falta",
  "1-3": "Pouca falta",
  "4-6": "Falta moderada",
  "7-10": "Muita falta",
  "+10": "Muita falta",
};
export const aproveitamentoList = [
  { value: "A_0", label: "0" },
  { value: "A_1", label: "1" },
  { value: "A_2", label: "2" },
  { value: "A_3", label: "3" },
  { value: "A_4", label: "4" },
  { value: "A_5", label: "5" },
  { value: "A_6", label: "6" },
  { value: "A_7", label: "7" },
  { value: "A_8", label: "8" },
  { value: "A_9", label: "9" },
  { value: "A_10", label: "10" },
  { value: "_10", label: "+10" },
];
export const escolaridadeList = [
  { value: "EP1", label: "Ensino Primário 1º Grau (1ª à 5ª classe)" },
  { value: "EP2", label: "Ensino Primário 2º Grau (6ª à 7ª classe)" },
  { value: "ESG1", label: "Ensino Secundário Geral 1º Ciclo (8ª à 10ª classe)" },
  { value: "ESG2", label: "Ensino Secundário Geral 2º Ciclo (11ª à 12ª classe)" },
  { value: "ENSINO_SUPERIOR", label: "Ensino Superior" },
  { value: "OUTRO", label: "Outro" },
];
export const sexoList = [
  { value: "M", label: "Masculino" },
  { value: "F", label: "Feminino" },
  { value: "I", label: "Indeterminado" },
];
